import usePureState from '@/hooks/usePureState';
import { Box } from '@chakra-ui/react';
import Content from './components/Content/Content';
import EventTypeForm from './components/ServiceForm/components/EventTypeForm/EventTypeFormSuccess';

export default function ServiceDetailsPage() {
	const { state, dispatch } = usePureState({ preview: false });

	return (
		<Box display="grid" gridTemplateColumns={{ base: '1fr', md: 'auto 1fr' }} h="100%" overflow="auto">
			<EventTypeForm isPreviewEnabled={state.preview} togglePreview={() => dispatch({ preview: true })} />
			<Content isPreviewEnabled={state.preview} togglePreview={() => dispatch({ preview: false })} />
		</Box>
	);
}
